import React from 'react'
import TeamRegistrationHomeNavigation from './TeamRegistrationHomeNavigation'
import RegisterAnotherTeam from '../../schedule/RegisterAnotherTeam'
import RegistrationPageGuard from '../../schedule/RegistrationPageGuard'

const RegisterAnotherTeamHome = () => {
	return (
		<RegistrationPageGuard navigation={<TeamRegistrationHomeNavigation />}>
			<RegisterAnotherTeam />
		</RegistrationPageGuard>
	)
}

export default RegisterAnotherTeamHome
